export const ADDRESS_NZ_SEARCH_FETCH_REQUEST = "ADDRESS_SEARCH_FETCH_REQUEST";
export const ADDRESS_NZ_SEARCH_FETCH_SUCCESS = "ADDRESS_SEARCH_FETCH_SUCCESS";
export const ADDRESS_NZ_SEARCH_FETCH_FAILURE = "ADDRESS_SEARCH_FETCH_FAILURE";
